import React from 'react'
import {Collapse} from "@material-ui/core";
import getObjectValue from "libs/getObjectValue";
import OffersNotDivided from "./OffersNotDivided";
import OffersDivided from "./OffersDivided";


function OffersData(
    {
        id,
        formikProps
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const partialOffers = gVal("form.orderObject.partialOffers", false)

    return (<>

        <Collapse in={partialOffers === false} unmountOnExit>
            <OffersNotDivided id={gId("notDivided")} formikProps={formikProps} />
        </Collapse>

        <Collapse in={partialOffers === true} unmountOnExit>
            <OffersDivided id={id} formikProps={formikProps}/>
        </Collapse>

    </>)
}

OffersData.propTypes = {};

export default OffersData;
